<template>
  <div class="flex-col section_8 space-y-12">
    <div class="flex-row justify-between items-center">
      <span class="font_4" v-if="!data.titleHidden">{{ data.title }}</span>
      <div class="flex-row" v-if="data.showAllButton" style="margin-left: auto">
        <span class="font_5 text_14">全部</span>
        <img class="shrink-0 image_7" src="https://ysh-cdn.kaidicloud.com/codefun/preview/4b14be31d64de5cffdbec2a890a32c97.png" />
      </div>
    </div>
    <div class="flex-row">
      <div class="flex-col justify-start items-center shrink-0 relative group_15">
        <img class="group_15" src="https://ysh-cdn.kaidicloud.com/codefun/preview/a82599daf0ea5c3c36b8bdfe36d2762f.png" />
        <div class="flex-col justify-start text-wrapper_5 pos_7"><span class="font_6 text_22">课程类别</span></div>
      </div>
      <div class="flex-col flex-auto group_16 space-y-4">
        <span class="font_2 text_23">服务型组织如何最佳实现数字化转型标题最多展示两行超出显…</span>
        <div class="flex-row items-center space-x-5">
          <img class="shrink-0 image_18" src="https://ysh-cdn.kaidicloud.com/codefun/preview/40731357b451cde4614de6ab4fa6f718.png" />
          <span class="font_7">中国企业发展模式研究院执行院长</span>
        </div>
      </div>
    </div>
    <div class="flex-row">
      <div class="flex-col justify-start items-center shrink-0 relative group_15">
        <img class="group_15" src="https://ysh-cdn.kaidicloud.com/codefun/preview/5cd46564c26bc955d22862b316ae70e8.png" />
        <div class="flex-col justify-start text-wrapper_5 pos_8"><span class="font_6 text_22">课程类别</span></div>
      </div>
      <div class="flex-col flex-auto group_17 space-y-22">
        <span class="self-start font_2">标题只有一行的效果</span>
        <div class="flex-row items-center space-x-5">
          <img class="shrink-0 image_18" src="https://ysh-cdn.kaidicloud.com/codefun/preview/40731357b451cde4614de6ab4fa6f718.png" />
          <span class="font_7">讲师介绍文案最多展示一行超出…</span>
        </div>
      </div>
    </div>
    <img class="self-center image_19" src="https://ysh-cdn.kaidicloud.com/codefun/preview/9816da84ea123ae3106c776cec136407.png" />
  </div>
</template>

<script>
export default {
  props: {
    content: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {}
  },
  computed: {
    data() {
      return this.content[0]
    },
  },
  methods: {},
}
</script>

<style lang="less" scoped>
.section_8 {
  padding: 24px;
  background-color: #ffffff;
  border-radius: 16px;
  .font_4 {
    font-size: 34px;
    font-family: 'PingFang SC';
    line-height: 48px;
    font-weight: 500;
    color: #222222;
  }
  .font_5 {
    font-size: 24px;
    font-family: 'PingFang SC';
    line-height: 34px;
    color: #999999;
  }
  .text_14 {
    font-size: 26px;
    line-height: 36px;
  }
  .image_7 {
    width: 36px;
    height: 36px;
  }
  .group_15 {
    border-radius: 12px;
    width: 224px;
    height: 128px;
    .text-wrapper_5 {
      padding: 4px 0;
      background-color: #00000080;
      border-radius: 12px 0px 12px 0px;
      .font_6 {
        font-size: 20px;
        font-family: 'PingFang SC';
        line-height: 28px;
        color: #ffffff;
      }
      .text_22 {
        margin: 0 8px;
      }
    }
    .pos_7 {
      position: absolute;
      left: 0;
      top: 0;
    }
    .pos_8 {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .group_16 {
    margin: 0 16px;
    .text_23 {
      text-align: justify;
    }
  }
  .space-y-4 {
    & > *:not(:first-child) {
      margin-top: 8px;
    }
  }
  .group_17 {
    margin: 4px 16px;
  }
  .space-y-22 {
    & > *:not(:first-child) {
      margin-top: 44px;
    }
  }
  .font_2 {
    font-size: 28px;
    font-family: 'PingFang SC';
    line-height: 40px;
    color: #222222;
  }
  .space-x-5 {
    & > *:not(:first-child) {
      margin-left: 10px;
    }
    .image_18 {
      width: 24px;
      height: 28px;
    }
    .font_7 {
      font-size: 24px;
      font-family: 'PingFang SC';
      line-height: 34px;
      color: #666666;
    }
  }
  .image_19 {
    width: 48px;
    height: 6px;
  }
}
.space-y-12 {
  & > *:not(:first-child) {
    margin-top: 24px;
  }
}
</style>
